import { mapActions, mapGetters } from 'vuex';

export default {
    methods: {
        ...mapActions('StatisticOperations', ['GET_LINK'])
    }
};
